/** SVG icon set — ported from the prototype (docs/design/project/components/core.jsx). */

const PATHS: Record<string, string> = {
  dashboard: 'M3 13h7V3H3v10zm0 8h7v-6H3v6zm9 0h7V11h-7v10zm0-18v6h7V3h-7z',
  txns: 'M3 6h18M3 12h18M3 18h12',
  menu: 'M3 6h18M3 12h18M3 18h18',
  invoice: 'M6 2h9l3 3v17H6zM9 8h6M9 12h6M9 16h4',
  clients: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM2 21a8 8 0 0116 0',
  accuracy: 'M3 21h18M3 17l4-4 4 4 6-6 4 4',
  alerts: 'M12 2a7 7 0 00-7 7v4l-2 3h18l-2-3V9a7 7 0 00-7-7zM10 21a2 2 0 004 0',
  settings:
    'M12 8a4 4 0 100 8 4 4 0 000-8zM19 12c0 .5-.05 1-.13 1.46l2 1.55-2 3.46-2.36-.95a7 7 0 01-2.5 1.45L13.6 22h-3.2l-.4-2.03a7 7 0 01-2.52-1.45l-2.36.95-2-3.46 2-1.55C5.05 13 5 12.5 5 12s.05-1 .13-1.46l-2-1.55 2-3.46 2.36.95a7 7 0 012.51-1.45L10.4 3h3.2l.4 2.03a7 7 0 012.51 1.45l2.36-.95 2 3.46-2 1.55c.08.46.13.96.13 1.46z',
  chevron: 'M9 18l6-6-6-6',
  chevronDown: 'M6 9l6 6 6-6',
  plus: 'M12 5v14m-7-7h14',
  close: 'M6 6l12 12M18 6L6 18',
  check: 'M5 13l4 4L19 7',
  arrowRight: 'M5 12h14m-6-6l6 6-6 6',
  edit: 'M4 20h4l10-10-4-4L4 16v4zM14 6l4 4',
  search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.3-4.3',
  download: 'M12 4v12m-5-5l5 5 5-5M5 21h14',
  bell: 'M12 2a7 7 0 00-7 7v4l-2 3h18l-2-3V9a7 7 0 00-7-7zM10 21a2 2 0 004 0',
  refresh: 'M3 12a9 9 0 0115-6.7L21 8M21 3v5h-5M21 12a9 9 0 01-15 6.7L3 16M3 21v-5h5',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 14h10l1-14',
  swap: 'M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4',
  logout: 'M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9',
  sparkles:
    'M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8L12 3zM18 14l1 2.5 2.5 1-2.5 1L18 21l-1-2.5L14.5 17.5l2.5-1L18 14z',
};

export interface IconProps {
  name: keyof typeof PATHS | string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export function Icon({ name, size = 16, strokeWidth = 1.7, className = '' }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[name] ?? PATHS.dashboard} />
    </svg>
  );
}
